// extracted by mini-css-extract-plugin
export var label = "styles-module--label--3GL5t";
export var title = "styles-module--title--6wlN5";
export var required = "styles-module--required--3Dhnm";
export var input = "styles-module--input--9fB_w";
export var textarea = "styles-module--textarea--RZO3H";